import { Classifier } from "../../util/classifierManager";

export enum InputName {
  county = "county",
  borough = "borough",
  village = "village",
}

export interface Input {
  [InputName.county]: Classifier;
  [InputName.borough]?: Classifier;
  [InputName.village]?: Classifier;
}
